import React from 'react'
import { Link, Route, Redirect, Switch, Header, Banner, Sidebar, ChatWidget, UserList, T } from 'components'
import { useSelector, usePublicLinks, useAdultRatings } from 'hooks'

import Browse from './Browse'
import Flirt from './Flirt'
import FindDate from './FindDate'
import Home from './Home'
import Mailbox from './Mailbox'
import StaticPage from '../Static/StaticPage'
import { MyProfile, UserProfile } from './Profile'
import Unsubscribe from './Unsubscribe/Unsubscribe'

import StyledApp, { StyledFooter } from './StyledApp'

const routes = [
  { to: '/', label: 'sections/home', exact: true },
  { to: '/browse', label: 'sections/browse' },
  { to: '/find-date', label: 'sections/findADate' },
  { to: '/flirt', label: 'sections/flirt' },
]

const insertProps = (params, pathname) => (params ? { pathname, ...params } : pathname)

const legacyRoutes = Object.entries({
  '/myprofile/update': '/myprofile/settings',
  '/games/flirt': '/flirt',
  '/search/visitors': '/browse?filters=visitors',
  '/search/friends': '/browse?filters=friends',
  '/mailbox/composeTo/:memberId/': '/mailbox/chat/',
}).map(([from, to]) => (
  <Route key={from} path={from} component={props => <Redirect to={insertProps(props?.match.params, to)} />} />
))

const App = () => {
  useAdultRatings()
  const links = usePublicLinks()
  const mailbox = useSelector(s => s.flags.mailbox)
  const extraRoutes = mailbox ? [{ to: '/mailbox', label: 'sections/mailbox' }] : []

  return (
    <StyledApp>
      <Sidebar
        routes={routes.concat(extraRoutes)}
        middle={<Banner />}
        bottom={<UserList vertical inverted placeholders={2} limit={3} filter="featured" title="featuredMembers" />}
      />
      <main>
        <Header />
        <Switch>
          {legacyRoutes}
          <Route path="/browse" component={Browse} />
          <Route path="/myprofile" component={MyProfile} />
          {mailbox && <Route path="/mailbox" component={Mailbox} />}
          {mailbox && <Route path="/mailbox/chat/" component={Mailbox} />}
          {mailbox && <Route path="/members/:nickname/chat" component={Mailbox} />}
          <Route path="/members/:nickname" component={UserProfile} />
          <Route path="/flirt" component={Flirt} />
          <Route path="/find-date" component={FindDate} />
          <Route path="/support/unsubscribe" component={Unsubscribe} />
          <Route path="/home" exact component={Home} />
          <Route path="/" exact component={Home} />
          <Route component={StaticPage} />
        </Switch>

        <StyledFooter>
          <nav>
            {links.map(link => (
              <T as={Link} className="nav-link" key={link.to} {...link} />
            ))}
          </nav>

          <p className="powered-by">
            <T label="poweredBy" /> Dating factory
          </p>
        </StyledFooter>
      </main>
      <ChatWidget />
    </StyledApp>
  )
}

export default App
